import AppURLs from "pages/AppInfo/AppUrl";
import httRoutes, { makeHTTUrl } from "pages/HTT/httRoute";

/**
 * 간편인증 실행 코드 (state.from 에 저장)
 * 간편인증/Processing 실행 때 현재 케이스 구분에 사용되는 코드
 * 추가로 넘겨야 할 값이 있는 경우는 state.extra 에 추가해서 실행
 * "EasyAuth."로 코드 검색해서 추가할 부분 확인
 */
export const EasyAuthRequestCode = {
  fetchHomeTax: "fetchHomeTax",
  fetchTaxAgent: "fetchTaxAgent",
  fetchPartial: "fetchPartial",   // SuhYB. 231019. 부분페칭 - 사용하지 않는 코드

  TaxPayment: "TaxPayment", // 신고 프로세스에서 넘어온 경우
  SummaryReport: "SummaryReport", // 신고 프로세스에서 넘어온 경우

  vatFetchData: "vatFetchData",
  makeVatReport: "makeVatReport",
  fetchVatNeedAuth: "fetchVatNeedAuth",

  fetchHttData: "fetchHttData", // 양도세 페칭
  fetchHttDataExtra: "fetchHttDataExtra", // 양도세 fake 페칭
};

/***************************************************************
 * 간편인증 실행조건 설정
 * state.from 값으로 간편인증 세부옵션 실행여부를 설정
 ***************************************************************/
// RequestEasyAuthSimple.jsx: requestAuth:
// 간편인증 실행하기 전 사용자에게 안내하는 화면을 출력하는 경우 아래에 코드를 기재
// Deprecated: 사용하지 않음!!: 변경될 수 있으니 -> isShowEasyAuthGuideCase 확인 필요
/* const ShowEasyAuthGuideList = [
  EasyAuthRequestCode.fetchHomeTax,
  EasyAuthRequestCode.fetchPartial,
] */

// RequestEasyAuthSimple.jsx: requestAuth:
// 사용하지 않음!!: 이미 저장된 주민번호가 있는 경우 주민번호 입력 화면을 건너뜀 (기본동작)
const SkipResRegNoCheckList = [
  EasyAuthRequestCode.fetchHomeTax,
  EasyAuthRequestCode.fetchTaxAgent,
  EasyAuthRequestCode.fetchPartial,
  EasyAuthRequestCode.vatFetchData,
  EasyAuthRequestCode.makeVatReport,
  EasyAuthRequestCode.fetchVatNeedAuth,
  EasyAuthRequestCode.fetchHttData,
  EasyAuthRequestCode.fetchHttDataExtra, // fake 페칭인 경우 주민번호 체크하지 않도록 주석처리
];

// RequestEasyAuthSimple.jsx: requestAuth:
// 사용하지 않음!!: 주민번호 입력이 필수인 케이스. 주민번호 입력 화면을 출력
const RequireResRegNoCheckList = [
  EasyAuthRequestCode.TaxPayment,
  EasyAuthRequestCode.SummaryReport,
];

// useEasyAuth: useEasyAuthComplete
// 간편 인증 완료 후 processing 단계로 넘어가는 경우
// (아래 리스트에 없는 경우는 useEasyAuthComplete 에서 별도로 처리 필요)
const NeedProcessingAfterEasyAuth = [
  EasyAuthRequestCode.fetchHttData,
  EasyAuthRequestCode.fetchHttDataExtra,
];

// Processing: loadImage
// 간편 인증 완료 -> processing: 대기화면 슬라이드 이미지를 CIT Hometax fetching 과 공유
// (아래 리스트에 없는 경우는 Processing.loadImage() 에서 별도로 처리 필요)
const UseCITWaitSlide = [
  EasyAuthRequestCode.fetchHttData,
  EasyAuthRequestCode.fetchHttDataExtra,
];

// Processing: processContent
// 간편 인증 완료 -> processing: 대기화면 UI를 CIT Hometax fetching 과 공유
// (아래 리스트에 없는 경우는 Processing.processContent 에서 별도로 처리 필요)
const UseCITProcessingLayout = [
  EasyAuthRequestCode.fetchHttData,
  EasyAuthRequestCode.fetchHttDataExtra,
];

// Processing: action
// 간편 인증 완료 -> processing: Processing 화면에서 실행할 action 을 CIT Hometax fetching 과 공유
// (아래 리스트에 없는 경우는 Processing.action 에서 별도로 처리 필요)
// (action 에서 실제 작업 및 후처리를 담당하므로 아래 리스트 대신 customize 추천!)
const UseCommonProcessingAction = [
  {
    from: EasyAuthRequestCode.fetchHttData,
    redirect_url: makeHTTUrl(httRoutes.overview.url),
  },
  {
    from: EasyAuthRequestCode.fetchHttDataExtra,
    redirect_url: makeHTTUrl(httRoutes.overview.url),
    fakeLoading: true,  // processing 대신 loading 시퀀스를 사용자에게 출력하는 예외 케이스
  },
];

/***************************************************************
 * 간편인증 실행조건 설정 끝
 ***************************************************************/

/**
 * utils
 * 간편인증 코드에서 호출하는 util 함수들
 */
// 간편인증 실행하기 전 사용자에게 안내하는 화면을 출력해야 하는지 확인
export const isShowEasyAuthGuideCase = (requestFrom) => {
  /* const found = ShowEasyAuthGuideList.find(
    (requestId) => requestId === requestFrom
  );
  return found !== undefined; */
  return false;
};

// 사용하지 않음!!: 이미 저장된 주민번호가 있는 경우 주민번호 입력 화면을 건너뜀 (기본동작)
export const isSkipResRegNoCheckCase = (requestFrom) => {
  const found = SkipResRegNoCheckList.find(
    (requestId) => requestId === requestFrom
  );
  return found !== undefined;
};

// 사용하지 않음!!: 주민번호 입력이 필수인 케이스. 주민번호 입력 화면을 출력
export const isResRegNoCheckCase = (requestFrom) => {
  const found = RequireResRegNoCheckList.find(
    (requestId) => requestId === requestFrom
  );
  return found !== undefined;
};

// 간편 인증 완료 후 processing 단계로 넘어가는 경우
export const isNeedProcessingAfterEasyAuth = (requestFrom) => {
  const found = NeedProcessingAfterEasyAuth.find(
    (requestId) => requestId === requestFrom
  );
  return found !== undefined;
};

// 간편 인증 완료 -> processing: 대기화면 슬라이드 이미지를 CIT Hometax fetching 과 공유
export const isUseCommonWaitSlide = (requestFrom) => {
  const found = UseCITWaitSlide.find((requestId) => requestId === requestFrom);
  return found !== undefined;
};

// 간편 인증 완료 -> processing: 대기화면 UI를 CIT Hometax fetching 과 공유
export const isUseCommonProcessingLayout = (requestFrom) => {
  const found = UseCITProcessingLayout.find(
    (requestId) => requestId === requestFrom
  );
  return found;
};

// 간편 인증 완료 -> processing: Processing 화면에서 실행할 action 을 CIT Hometax fetching 과 공유
export const isUseCommonProcessingAction = (requestFrom) => {
  const found = UseCommonProcessingAction.find(
    (item) => item.from === requestFrom
  );
  return found;
};

/***************************************************************
 * 간편인증 / Processing 화면 실행 함수
 ***************************************************************/
/**
 * 간편인증 프로세스 실행
 * 
 * @param {*} history       화면전환을 위한 history 객체
 * @param {*} requestFrom   간편인증 프로세스 실행을 위한 고유 코드
 * @param {*} extra         간편인증 프로세스 실행을 위한 추가 정보, 완료 후 redirect 페이지로 전달될 파라미터
 */
export const goToEasyAuth = (history, requestFrom, extra) => {
  history.push(AppURLs.common.requestAuth, {
    from: requestFrom,
    extra: extra,
  });
};

/**
 * 페칭(Processing) 프로세스만 실행
 * 
 * @param {*} history       화면전환을 위한 history 객체
 * @param {*} requestFrom   페칭 프로세스 실행을 위한 고유 코드
 * @param {*} extra         페칭 프로세스 실행을 위한 추가 정보, 완료 후 redirect 페이지로 전달될 파라미터
 */
export const goToProcessing = (history, requestFrom, extra) => {
  history.replace(AppURLs.common.processing, {
    jobProcess: requestFrom,
    extra: extra,
  });
};
